<template>
  <div class="paginator">
    <ButtonIcon
      :active="page > 1 ? true : null"
      icon="back"
      size="large"
      @click="emits('prev')"
    />
    <div class="page-number">{{ page }} of {{ numPages }}</div>
    <ButtonIcon
      :active="page < numPages ? true : null"
      icon="forward"
      size="large"
      @click="emits('next')"
    />
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  page: {
    type: Number,
    required: true,
  },
  numPages: {
    type: Number,
    required: true,
  },
})

const emits = defineEmits(["prev", "next"])

const { $gsap, $ScrollTrigger } = useNuxtApp()

const { app, debug, browser } = useStores()

const refRoot = ref(null)
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";

.paginator {
  width: fit-content;
  @include flex(center);
  margin-block: $p4;
}

.page-number {
  margin-inline: $p8;
}

.btn-back {
  transform: scaleX(-1);
}
</style>
